module.exports = __webpack_public_path__ + "img/person.5fc8d1fa.png";